var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 76,
    viewBox: "0 0 95 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.9026 22.5923H0V30.1845H94.9026V22.5923Z",
    fill: "#0D659B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9026 45.1846H0V52.7769H94.9026V45.1846Z",
    fill: "#009E4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9026 0H0V7.5923H94.9026V0Z",
    fill: "#009E4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9026 67.7769H0V75.3692H94.9026V67.7769Z",
    fill: "#0D659B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.6e4d2e667f8671d47957f8f297879dfb.svg";
export { ForwardRef as ReactComponent };